import _dottedPathToPopulation from '@/shared/functions/population-helpers/_dottedPathToPopulation';
import standardTireDotPopulation from '@/shared/functions/population-helpers/standardTireDotPopulation';
import standardTireSizePopulation from '@/shared/functions/population-helpers/standardTireSizePopulation';

export default function standardProductBundleItemPopulation(
  path: string = '',
  {
    populateRoot = true,
    populateTireDot = true,
  }: {
    populateRoot?: boolean;
    populateTireDot?: boolean;
  } = {}
) {
  const p = _dottedPathToPopulation(path);
  return {
    ...(populateRoot ? { [`populate${p}`]: 1 } : {}),
    ...standardTireSizePopulation(`${path}.tireSize`, { populateRoot: true, populateTireDot }),
    ...(populateTireDot
      ? standardTireDotPopulation(`${path}.tireDot`, { populateRoot: true })
      : {}),
  };
}
